/* eslint-disable camelcase */
/* eslint-disable camelcase */
const actions = {
  SET_STATE: 'dashboard/SET_STATE',
  GET_USER_DASHBOARD: 'dashboard/GET_USER_DASHBOARD',
}

export default actions
